<script lang="ts">
    import { afterUpdate, onMount } from 'svelte';
    import { idPageHome, storeFirstDisplayHome } from "../scripts/router2";
    import HomeShowcase from '../components/HomeShowcase.svelte';
    import HomePresentation from '../components/HomePresentation.svelte';
    import HomeKeyNumber from '../components/HomeKeyNumber.svelte';
    import HomeDescription from '../components/HomeDescription.svelte';
    import HomePartenaires from '../components/HomePartenaires.svelte';
    import HomePleniere from '../components/HomePleniere.svelte';
    import { resetToActivate } from '../scripts/login';
    import { redirection } from '../scripts/redirection';

    onMount(async () => {
        window.scrollTo(0,0);
	});

    afterUpdate(() => {
        window.scrollTo(0,0);
    })

</script>
    
<style lang="scss">

    .home {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
    }

</style>

<div class="home">
    <HomeShowcase />
    <HomePresentation />
    <HomeKeyNumber />
    <HomeDescription />
    <HomePartenaires />
    <HomePleniere />
</div>
